// Usuario en sesión para el campo `usuario` de los movimientos generados en
// cliente (CRUD, ajustes de stock). Se rellena en la Fase 8 desde la sesión
// real de InsForge. Las operaciones de kits/traslados derivan el usuario en el
// servidor (Edge Functions), así que no dependen de esto.
let _usuario = '';

export function setUsuarioActual(usuario: string | null | undefined): void {
  _usuario = usuario ?? '';
}

export function getUsuarioActual(): string {
  return _usuario || 'sistema';
}
